import React from 'react';
import { Stack } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import useTranslate from 'hooks/useTranslate';
import {
	FACEBOOK_URL,
	TWITTER_URL,
	LINKEDIN_URL,
	INSTAGRAM_URL,
	YOUTUBE_URL,
	TIKTOK_URL,
	USER_TYPES,
} from 'constants/index';
import './styles.scss';
import useAuthStore from 'store/auth';

const QuickLinksBox: React.FC = () => {
	const { user: authUser }: Record<string, any> = useAuthStore((state) => state.userInfo ?? {});
	const { translate } = useTranslate();

	return (
		<div className="quick-links bg-white">
			<Stack className="quick-links-inner gap-3">
				<div>
					<h6 className="fw-bold mb-2">{translate('Footer.discover')}</h6>
					<div className="d-flex flex-wrap gap-3">
						{authUser?.userType !== USER_TYPES?.COMPANY && (
							<Link to="/job-search">{translate('Footer.browseAJob')}</Link>
						)}
						<Link to="/how-it-works">{translate('Footer.howItWorks')}</Link>
					</div>
				</div>

				<div>
					<h6 className="fw-bold mb-2">{translate('Footer.company')}</h6>
					<div className="d-flex flex-wrap gap-3">
						<Link to="/about">{translate('Footer.aboutUs')}</Link>
						<Link to="/terms-conditions">{translate('Footer.termsConditions')}</Link>
						<Link to="/privacy-policy">{translate('Footer.privacyPolicy')}</Link>
					</div>
				</div>
				<div>
					<h6 className="fw-bold mb-2">{translate('Footer.contact')}</h6>
					<div className="d-flex flex-wrap gap-3">
						<Link to="/contact-us">{translate('Footer.contactUs')}</Link>
						<Link to="/faqs">{translate('Footer.fAQ')}</Link>
					</div>
				</div>
			</Stack>
			<div className="follow-us d-flex align-items-center gap-3">
				<h6 className="fw-bold mb-0">{translate('Footer.followUs')}</h6>
				<div className="social-links d-flex gap-2">
					<a
						href={FACEBOOK_URL}
						className="rounded-circle"
						target="_blank"
						rel="noopener noreferrer"
					>
						<i className="ri-facebook-fill"></i>
					</a>
					<a
						href={TWITTER_URL}
						className="rounded-circle"
						target="_blank"
						rel="noopener noreferrer"
					>
						<i className="ri-twitter-x-fill"></i>
					</a>
					<a
						href={LINKEDIN_URL}
						className="rounded-circle"
						target="_blank"
						rel="noopener noreferrer"
					>
						<i className="ri-linkedin-fill"></i>
					</a>
					<a
						href={INSTAGRAM_URL}
						className="rounded-circle"
						target="_blank"
						rel="noopener noreferrer"
					>
						<i className="ri-instagram-fill"></i>
					</a>
					<a
						href={YOUTUBE_URL}
						className="rounded-circle"
						target="_blank"
						rel="noopener noreferrer"
					>
						<i className="ri-youtube-fill"></i>
					</a>
					<a href={TIKTOK_URL} className="rounded-circle" target="_blank" rel="noopener noreferrer">
						<i className="ri-tiktok-fill"></i>
					</a>
				</div>
			</div>
		</div>
	);
};

export default QuickLinksBox;
